module.exports = __webpack_public_path__ + "img/logo-defi-ville-intelligente-cropped.d414f8af.png";